import { render, staticRenderFns } from "./FriendZoneButton.vue?vue&type=template&id=0ce24ffc&scoped=true&"
import script from "./FriendZoneButton.vue?vue&type=script&lang=js&"
export * from "./FriendZoneButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce24ffc",
  null
  
)

export default component.exports